"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDGETS_STATES = void 0;
var WIDGETS_STATES = exports.WIDGETS_STATES = {
  NEVER: 0,
  AUTO: 1,
  ALWAYS: 2
};